import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ChartComponent, ApexAxisChartSeries, ApexChart, ApexXAxis, ApexTitleSubtitle } from 'ng-apexcharts';
import { ChartDefinition } from '../../service/factory/chart-definition-factory.service';

// Documentation of ApexChart options here: https://apexcharts.com/docs/options/xaxis/

@Component({
    selector: 'app-chart',
    templateUrl: './apex-chart.component.html',
    styleUrls: ['./apex-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApexChartComponent {
  @ViewChild('chart') chart: ChartComponent;
  @Input() chartOptions: ChartDefinition;
}
